module.exports = __webpack_public_path__ + "static/media/logomain.6cc65abd.webp";